<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-6">
                    <h2>Servidores para videojuegos</h2>
                </div>

                <div class="col-lg-6 col-md-6">
                    <ul>
                        <li><a routerLink="/">Inicio</a></li>
                        <li>Servicios</li>
                        <li>Servidores para videojuegos</li>
                    </ul>
                </div>
            </div>

            <div class="special-intro-offer-wrap">
                <div class="row">
                    <h4 style="color: #FFF;">Juegos Populares</h4>
                    <div class="col-lg-4 col-sm-12">
                        <div class="reseller-item">
                            <img src="assets/img/games/Terraria.webp" alt="Image">
                            <h3>Terraria</h3>
                        </div>
                    </div>
                    <div class="col-lg-4 col-sm-12">
                        <div class="reseller-item">
                            <img src="assets/img/games/Minecraft.webp" alt="Image">
                            <h3>Minecraft</h3>
                        </div>
                    </div>
                    <div class="col-lg-4 col-sm-12">
                        <div class="reseller-item">
                            <img src="assets/img/games/ARK.webp" alt="Image">
                            <h3>ARK</h3>
                        </div>
                    </div>


                </div>
            </div>
        </div>
    </div>
</div>







<section class="customer-support-area pt-70">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-12 col-md-12">
                <div class="customer-title">
                    <h2 class="text-center">¿Qué es un Servidor de Videojuegos?</h2>
                    <p class="text-justify">
                        Un Servidor de Videojuegos es una máquina dedicada que aloja partidas multijugador en línea, proporcionando una conexión estable y rápida entre los jugadores. Contar con un servidor propio te da control total sobre las reglas, mods, rendimiento y seguridad del juego, sin depender de servidores públicos congestionados.


                    </p>
                    <p class="text-justify"> En enCloud, ofrecemos una infraestructura optimizada para gaming, con tecnología de punta que garantiza rendimiento superior, baja latencia y máxima seguridad.</p>
                </div>
            </div>
        </div>
    </div>
</section>



<section class="customer-support-area pt-70">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-12 col-md-12">


                <div class="customer-title">
                    <h2 class="text-center">Ventajas de un Servidor de Videojuegos en enCloud</h2>
                    <ul class="custom-list">
                        <li><strong>Baja latencia y conexiones estables</strong> – – Servidores en data centers optimizados con redes de alto rendimiento.</li>
                        <li><strong>Hardware de alto nivel</strong> – CPUs potentes, almacenamiento SSD NVMe y gran ancho de banda para un rendimiento sin interrupciones.</li>
                        <li><strong>Personalización total</strong> –  Instala mods, plugins y configura las reglas de tu servidor a tu gusto.</li>
                        <li><strong>Protección avanzada contra DDoS</strong> – Seguridad de primer nivel para evitar ataques y caídas inesperadas.</li>

                        <li><strong>Soporte 24/7 con expertos en videojuegos</strong> – AAtención especializada para resolver cualquier problema técnico.</li>
                        <li><strong>Backups automáticos y recuperación rápida</strong> – Respalda y restaura tu servidor en segundos.
                        </li>
                        <li><strong>Opciones de escalabilidad</strong> – Expande el servidor en cualquier momento según tus necesidades.
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</section>



<section class="customer-support-area pt-70">

    <div class="container">
        <h1 class="text-center">Juegos Compatibles con Nuestros Servidores</h1>

        <div class="row align-items-center">
            <div class="col-lg-12 col-md-12">
                <div class="frequently-content-wrap">
                    <ul>
                        <li>
                            <i class="fa-solid fa-crown"></i>
                            <h3>FPS y Battle Royale</h3>
                            <div class="row">
                                <a>🔹 <strong>Counter-Strike 2 (CS2) </strong>– Servidores de matchmaking, retakes,
                                    surf, zombie escape,
                                    etc.</a>
                                <a>🔹 <strong>ARMA 3 </strong>– Simulación militar con mods y personalización avanzada.
                                </a>
                                <a>🔹 <strong>Squad </strong> – Servidores para clanes competitivos con bajas latencias.
                                </a>

                            </div>
                        </li>
                        <li>
                            <i class="fa-solid fa-shield-halved"></i>
                                                        <h3>Sandbox y Survival</h3>
                            <div class="row">
                                <a>🔹 <strong>Minecraft (Java & Bedrock) </strong>– Soporte para Bukkit, Spigot, Paper, Forge y
                                    Fabric.</a>
                                <a>🔹 <strong>Valheim </strong>– Servidores para comunidades vikingas con mods y ajustes personalizados.
                                </a>
                                <a>🔹 <strong>Rust </strong>– Hosting optimizado para grandes comunidades y eventos PvP.
                                </a>
                                <a>🔹 <strong>Terraria </strong>– Servidores con soporte para TShock y mods personalizados.
                                </a>


                            </div>
                        </li>

                        <li>
                            <i class="fa-solid fa-person-walking"></i>                            <h3>MMORPG y RPG</h3>
                            <div class="row">
                                <a>🔹 <strong>World of Warcraft (Private Server) </strong> – Servidores personalizados para WoW Classic,
                                    WotLK, Cata, etc.</a>
                                <a>🔹 <strong>ARK: Survival Evolved </strong>– Hosting con soporte para mods y tribus.</a>
                                <a>🔹 <strong>Conan Exiles </strong>– Servidores de rol con administración avanzada.</a>
                            </div>
                        </li>

                        <li>
                            <i class="fa-solid fa-gamepad"></i>
                            <h3>Otros</h3>
                            <div class="row">
                                <a>🔹 <strong>GTA V (FiveM & RageMP) </strong>– Hosting para servidores de roleplay con mods
                                    avanzados.</a>
                                <a>🔹 <strong>Factorio </strong>– Servidores dedicados para cooperativo sin interrupciones.</a>
                                <a>🔹 <strong>Left 4 Dead 2 </strong>– Servidores para campañas y versus personalizados.</a>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>


    </div>
</section>

<div class="brand-area {{pb}} {{pt}}">
    <div class="container">
        <div class="row">
            <div class="brand-wrap owl-carousel owl-theme">
                <div class="single-brand-custom">
                    <img src="assets/img/games/Terraria.webp" alt="Image">
                    <a class="carousel-name">Terraria</a>

                </div>
                <div class="single-brand-custom">
                    <img src="assets/img/games/ARK.webp" alt="Image">
                    <a class="carousel-name">ARK</a>


                </div>
                <div class="single-brand-custom">
                    <img src="assets/img/games/Arma_3.webp" alt="Image">
                    <a class="carousel-name">Arma 3</a>


                </div>
                <div class="single-brand-custom">
                    <img src="assets/img/games/Minecraft.webp" alt="Image">
                    <a class="carousel-name">Minecraft</a>


                </div>
                <div style="" class="single-brand-custom">
                    <img src="assets/img/games/Valheim.webp" alt="Image">
                    <a  class="carousel-name">Valheim</a>

                </div>

            </div>
        </div>
    </div>
</div>


<section class="pricing-area pt-100">
    <div class="container">
        <div class="section-title">
            <h2>📦 Planes y Configuraciones Disponibles</h2>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="single-pricing">
                    <div class="pricing-top-heading">
                        <h3>Servidor básico</h3>
                        <p>Para juegos ligeros</p>
                    </div>
                    <div class="custom-price-panel">
                        <span>Características:</span>
                        <ul>
                            <li><i class="flaticon-tick"></i>2 vCPU | 4 GB RAM | 50 GB SSD | 250 Mbps BW</li>
                            <li><i class="flaticon-tick"></i> Ideal para Minecraft Vanilla, Terraria, Valheim y
                                Factorio.</li>
                            <li><i class="flaticon-tick"></i> Hasta 10 jugadores simultáneos sin lag.</li>
                            <li><i class="flaticon-tick"></i> Soporte para mods y configuraciones personalizadas.</li>
                            <li><i class="flaticon-tick"></i> Protección contra ataques DDoS.</li>

                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="single-pricing">
                    <div class="pricing-top-heading">
                        <h3>Servidor competitivo</h3>
                        <p>Para FPS y juegos con alta demanda de red</p>
                    </div>
                    <div class="custom-price-panel">
                        <span>Características:</span>
                        <ul>
                            <li><i class="flaticon-tick"></i>4 vCPU | 8 GB RAM | 100 GB SSD | 500 Mbps BW</li>
                            <li><i class="flaticon-tick"></i> Optimizado para CS2, ARMA 3, Call of Duty, Rust y Squad.
                            </li>
                            <li><i class="flaticon-tick"></i> Hasta 25 jugadores simultáneos sin lag.</li>
                            <li><i class="flaticon-tick"></i> Baja latencia y conexión estable para partidas
                                competitivas.</li>
                            <li><i class="flaticon-tick"></i> Soporte para mods y configuraciones personalizadas.</li>
                            <li><i class="flaticon-tick"></i> Protección contra ataques DDoS y backups automáticos.</li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="single-pricing">
                    <div class="pricing-top-heading">
                        <h3>Servidor MMO & Roleplay</h3>
                        <p>Para juegos masivos y simulaciones</p>
                    </div>
                    <div class="custom-price-panel">
                        <span>Características:</span>
                        <ul>
                            <li><i class="flaticon-tick"></i>8 vCPU | 16 GB RAM | 250 GB SSD | 1 Gbps BW</li>
                            <li><i class="flaticon-tick"></i> Perfecto para WoW Private Servers, GTA V (FiveM), Conan
                                Exiles, ARK y DayZ.</li>
                            <li><i class="flaticon-tick"></i> Soporte para grandes comunidades, hasta 100 jugadores
                                simultáneos.</li>
                            <li><i class="flaticon-tick"></i> Infraestructura escalable con administración avanzada.
                            </li>
                            <li><i class="flaticon-tick"></i> Soporte para mods y configuraciones personalizadas.</li>
                            <li><i class="flaticon-tick"></i> Protección contra ataques DDoS y backups automáticos.</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>


<app-vs-others></app-vs-others>

<app-contact-form [section]="section" [pt]="pt" [pb]="pb" [title]="title"></app-contact-form>

<app-clients [pt]="pt" [pb]="pb"></app-clients>